import React from "react";
//** NDBX */
import { Section, TwoColumnStack } from "@arp/react-ndbx";
//** Components */
import { Discount } from "./Discount.jsx";
//** MUI */
import { Typography, Divider, Container, Stack } from "@mui/material";
//** Context */
import usePreQualification from "../../../hooks/usePreQualification";

//**Hooks */
import { useGetQuote } from "../../../hooks/dataHooks/useGetQuoteData.js";

//** Utilities */
import { formatCurrency } from "../../../utilities/numericFormat.js";

export const CombinedQuoteSummary = ({ ...props }) => {
  const { data, isLoading, isFetching, error } = useGetQuote();

  if (isLoading || isFetching) {
    return;
  }

  const { quoteInformation, personOneQuoteInfo, personTwoQuoteInfo } = {
    ...data,
  };
  const { policyPremiumsTotal, discountPercentage } = { ...quoteInformation };

  const { frequency, amount } = { ...props };
  const { dataSet } = usePreQualification();
  const { personOne, personTwo } = { ...dataSet };

  const frequencyDisplay = { monthly: "monthly", annual: "yearly" };
  const discountApplied = discountPercentage > 0 ? true : false;

  const Individual = ({ person, frequency, personQuoteInfo }) => {
    return (
      <Stack spacing={2}>
        <Typography variant="h5">
          {person.firstName}, your {frequencyDisplay[frequency]} <br /> premium
          is
        </Typography>
        <Typography variant="h2-bold">
          {formatCurrency(personQuoteInfo.insuredPremiums[frequency])}
        </Typography>
      </Stack>
    );
  };

  return (
    <>
      {data ? (
        <Container maxWidth="sm">
          <Section mt={2}>
            <Typography variant="h5">
              The total combined
              <Typography variant="h5-bold">
                {" "}
                {`${frequencyDisplay[frequency]} premium`}{" "}
              </Typography>
              is
            </Typography>
          </Section>

          <Section mt={2}>
            <Typography variant="h2-bold">{`${formatCurrency(
              policyPremiumsTotal[frequency]
            )}`}</Typography>
          </Section>

          {discountApplied ? (
            <Section>
              <Discount />
              <Section mt={4}>
                <Divider variant="middle" />
              </Section>
            </Section>
          ) : null}

          <TwoColumnStack mt={4} direction={{ xs: "column", sm: "row" }}>
            <Section>
              <Individual
                person={personOne}
                frequency={frequency}
                personQuoteInfo={personOneQuoteInfo}
              />
            </Section>
            <Section>
              <Individual
                person={personTwo}
                frequency={frequency}
                personQuoteInfo={personTwoQuoteInfo}
              />
            </Section>
          </TwoColumnStack>
        </Container>
      ) : null}
    </>
  );
};
